<template>
  <vue-scroll class="download-page">
    <bCardHeader :param="param"
                 class="card-header"></bCardHeader>
    <el-row :gutter="40">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              v-for="(parent, parentKey) in downloadMethodsArr"
              :key="parentKey">
        <div class="download-item">
          <h3 class="title">{{getKey(parent.title)}}</h3>
          <el-row :gutter="20">
            <el-col v-for="(children, childrenKey) in parent.children"
                    :key="childrenKey"
                    :xs="24"
                    :sm="24"
                    :md="24"
                    :lg="12"
                    :xl="12">
              <a class="icon-item"
                 :href="children.href"
                 @click="dialog(children.isVisible, children.QR_code, children.txt)"
                 :target="children.target"
                 :class="{'hidden-item': children.txt == 'null'}">
                <img :src='children.image'
                     alt=""
                     class="img-box">
                <span class="text-box">{{getKey(children.txt)}}</span>
              </a>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 苹果与安卓的下载二维码弹窗 -->
    <el-dialog title=""
               :visible.sync="centerDialogVisible"
               width="10%"
               center>
      <img :src="dialogImgSrc"
           width="100%"
           alt="">
    </el-dialog>

  </vue-scroll>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      param: {
        title: 'download',
        links: [{ title: 'home' }, { title: 'download' }]
      },
      downloadMethodsArr: [
        {
          title: 'stock_download_title',
          children: [
            {
              image: require('@/assets/images/download/iOS.png'),
              txt: 'stock_iOS',
              target: '_blank',
              isVisible: false,
              href: 'https://apps.apple.com/cn/app/id1448584180',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/Android.png'),
              txt: 'stock_Android',
              target: '_blank',
              isVisible: false,
              href: 'https://a.app.qq.com/o/simple.jsp?pkgname=io.newtype.eddid.app',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/Microsoft.png'),
              txt: 'stock_Microsoft',
              target: '_blank',
              isVisible: false,
              href:
                'https://www.eddidsf.com/uploads/download_files/full/smx_FUT_9.22.exe',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/web.png'),
              txt: 'stock_web',
              target: '_blank',
              isVisible: false,
              href:
                'https://trade.eddidsec.com/mts.web/Web2/login/fsec/index.html#gb',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/security-code.png'),
              txt: 'stock_security_code_ios',
              target: '',
              isVisible: true,
              href: 'javascript:void(0)',
              QR_code: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/images/security_code_ios.png'
            },
            {
              image: require('@/assets/images/download/security-code.png'),
              txt: 'stock_security_code_android',
              target: '_blank',
              isVisible: false,
              href:
                'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/apk/security_code_android.apk',
              QR_code: ''
            }
          ]
        },
        {
          title: 'fx_MT5_download_title',
          children: [
            {
              image: require('@/assets/images/download/iOS.png'),
              txt: 'fx_mt5_for_iPhone',
              target: '_blank',
              isVisible: false,
              href:
                'https://itunes.apple.com/cn/app/metatrader-5-forex-stocks/id413251709',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/Android.png'),
              txt: 'fx_mt5_for_Android',
              target: '_blank',
              isVisible: false,
              href:
                'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/apk/iTradesolution-EDDIDAccountUnlocker.apk',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/software.png'),
              txt: 'fx_mt5_eddid_ios',
              target: '_blank',
              isVisible: false,
              href: 'https://apps.apple.com/cn/app/id1451160628?l=en',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/software.png'),
              txt: 'fx_mt5_eddid_android',
              target: '_blank',
              isVisible: false,
              href:
                'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/apk/metatrader5forAndroid.apk',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/Microsoft.png'),
              txt: 'fx_mt5_for_Windows',
              target: '_blank',
              isVisible: false,
              href: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/apk/Windows.exe',
              QR_code: ''
            }
          ]
        },
        {
          title: 'futures_download_title',
          children: [
            {
              image: require('@/assets/images/download/eddidpro.png'),
              txt: 'eddid_pro',
              target: '_blank',
              isVisible: false,
              href:
                'https://eddidapp-package.oss-cn-shenzhen.aliyuncs.com/EddidProInstaller.exe',
              QR_code: ''
            },
            {
              image: require('@/assets/images/download/eddidlite.png'),
              txt: 'eddid_lite',
              target: '_blank',
              isVisible: false,
              href:
                'https://eddidapp-package.oss-cn-shenzhen.aliyuncs.com/EddidLiteInstaller.exe',
              QR_code: ''
            }
            // {
            //   image: require('@/assets/images/download/manual.png'),
            //   txt: 'futures_use_download',
            //   target: '_blank',
            //   isVisible: false,
            //   href: 'https://www.eddidsf.com/uploads/soft/20200526/20200526134227.pdf',
            //   QR_code: ''
            // }
          ]
        }

      ],
      centerDialogVisible: false,
      dialogImgSrc: ''
    }
  },
  computed: {
    ...mapGetters(['getClientProfile'])
  },
  mounted () {
    const nationality = this.getClientProfile.userInfo.issuingCountry
    console.log('nationality', nationality)
    // if (nationality === 'CHN') {
    // let MT5Obj = {
    //   title: 'fx_MT5_download_title',
    //   children: [
    //     {
    //       image: require('@/assets/images/logo/page2_ios.png'),
    //       txt: 'fx_mt5_for_iPhone',
    //       target: '_blank',
    //       isVisible: false,
    //       href:
    //         'https://itunes.apple.com/cn/app/metatrader-5-forex-stocks/id413251709',
    //       QR_code: ''
    //     },
    //     {
    //       image: require('@/assets/images/logo/page2_android.png'),
    //       txt: 'fx_mt5_for_Android',
    //       target: '_blank',
    //       isVisible: false,
    //       href:
    //         'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/apk/iTradesolution-EDDIDAccountUnlocker.apk',
    //       QR_code: ''
    //     },
    //     {
    //       image: require('@/assets/images/logo/eddid-unlock.png'),
    //       txt: 'fx_mt5_eddid_ios',
    //       target: '_blank',
    //       isVisible: false,
    //       href: 'https://apps.apple.com/cn/app/id1451160628?l=en',
    //       QR_code: ''
    //     },
    //     {
    //       image: require('@/assets/images/logo/eddid-unlock.png'),
    //       txt: 'fx_mt5_eddid_android',
    //       target: '_blank',
    //       isVisible: false,
    //       href:
    //         'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/apk/metatrader5forAndroid.apk',
    //       QR_code: ''
    //     },
    //     {
    //       image: require('@/assets/images/Microsoft.png'),
    //       txt: 'fx_mt5_for_Windows',
    //       target: '_blank',
    //       isVisible: false,
    //       href: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/apk/Windows.exe',
    //       QR_code: ''
    //     }
    //   ]
    // }
    // this.downloadMethodsArr.push(MT5Obj)
  },

  methods: {
    getKey (key) {
      let item = this.$t('download')
      return item[key] ? item[key] : key
    },
    dialog (boolean, img, txt) {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        // mobile
        this.centerDialogVisible = false
        if (txt === 'stock_iOS') {
          // ios
          this.downloadMethodsArr[0].children[0].href =
            'https://itunes.apple.com/cn/app/%E8%89%BE%E5%BE%B7%E9%87%91%E8%9E%8D/id1448584180?l=zh&ls=1&mt=8'
        } else if (txt === 'stock_Android') {
          // Android
          this.downloadMethodsArr[0].children[1].href =
            'https://www.eddid.com.hk/wp-content/uploads/app/eddid-finance-app.apk'
        } else if (txt === 'fx_pro_for_iPhone') {
          this.downloadMethodsArr[1].children[0].href =
            'https://www.eddid.com.hk/wp-content/uploads/files/aidejiaoyibao_android_20190319.apk'
        } else if (txt === 'fx_pro_for_Android') {
          this.downloadMethodsArr[1].children[1].href =
            'https://play.google.com/store/apps/details?id=com.mfinance.android.eddid&hl=zh-hant'
        } else if (txt === 'fx_mt5_for_iPhone') {
          this.downloadMethodsArr[1].children[1].href =
            'https://download.mql5.com/cdn/mobile/mt5/ios?server=EddidSecurities-Live'
        } else if (txt === 'stock_security_code_ios') {
          this.downloadMethodsArr[0].children[4].href = 'https://apps.apple.com/cn/app/%E8%89%BE%E5%BE%B7%E4%BF%9D%E5%AE%89%E7%B7%A8%E7%A2%BC/id1374057039'
        }
      } else {
        // pc
        this.centerDialogVisible = boolean
        var language = sessionStorage.getItem('language')
        if (
          language === 'cn' &&
          img ===
          'http://download.eddidapp.com/images/android-erweima-hans.jpg'
        ) {
          this.dialogImgSrc =
            'https://www.eddid.com.hk/zh-hans/wp-content/themes/enfold-eddid/assets/images/an-erweima-hans.jpg'
        } else {
          this.dialogImgSrc = img
        }
        // if (txt === 'fx_pro_for_iPhone') {
        //   this.dialogImgSrc = require('@/assets/images/fx_pro_iOS.png')
        // } else if (txt === 'fx_pro_for_Android') {
        //   this.dialogImgSrc = require('@/assets/images/fx_pro_Android.png')
        // }
      }
    }
  }
}
</script>
<style lang="scss">
.download-page {
  .download-item {
    padding: 20px 30px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 3px 7px 0 rgba(179, 179, 179, 0.5);
    margin-bottom: 20px;
  }
  .title {
    font-size: 18px;
    color: #182a54;
    border-bottom: 3px solid #ebebeb;
    padding-bottom: 20px;
  }
  .icon-item {
    text-decoration: none;
    display: block;
    color: inherit;
    box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5);
    border-radius: 5px;
    padding: 16px 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
      display: inline-block;
      font-size: 16px;
      font-weight: normal;
      color: #24282d;
      line-height: 16px;
    }
  }
  .hidden-item {
    visibility: hidden;
  }
  .img-box {
    width: 38px;
    height: 38px;
    vertical-align: middle;
  }
}
</style>
